import * as React from "react";
const SvgFiRrCloudMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-moon_svg__a)">
      <path
        fill="#062147"
        d="m20.305 14.172-.175-.042c-.3-.068-.452-.1-.588-.427a6 6 0 0 0-11.367.856 6.4 6.4 0 0 0-.057 2.73 3.5 3.5 0 0 0 .451 6.59q.409.106.83.12c1.567.04 8.201.03 9.694 0a5.2 5.2 0 0 0 1.066-.131c5.009-1.125 5.07-8.418.146-9.696m1.612 5.553a2.98 2.98 0 0 1-2.858 2.274c-1.655.032-8.258.037-9.6 0a1.47 1.47 0 0 1-1.402-1.075 1.494 1.494 0 0 1 .85-1.8 2.02 2.02 0 0 0 1.18-2.306 4 4 0 0 1 3.305-4.778 4.03 4.03 0 0 1 4.3 2.427 2.72 2.72 0 0 0 2.093 1.633 3.02 3.02 0 0 1 2.132 3.625M5.261 17.613a1 1 0 0 1-1.4.177A9.91 9.91 0 0 1 .064 8.88 10.035 10.035 0 0 1 8.361.127 10.8 10.8 0 0 1 12.522.3a2.22 2.22 0 0 1 1.6 1.6 2.2 2.2 0 0 1-.619 2.153 7.85 7.85 0 0 0-2.513 4.71 1.003 1.003 0 0 1-1.115.896 1 1 0 0 1-.87-1.136 9.85 9.85 0 0 1 3.13-5.93.18.18 0 0 0 .05-.192.21.21 0 0 0-.153-.16A8.8 8.8 0 0 0 8.674 2.1a8.01 8.01 0 0 0-6.621 6.986 7.93 7.93 0 0 0 3.031 7.124 1 1 0 0 1 .177 1.403"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-moon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudMoon;
